import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { IconClose } from '@prisjakt/ui/icon/close';
import { AppContext } from 'src/components/app-context';
import { Row } from '@prisjakt/ui/list/variants';
import actions from '../../actions';

import { SearchIcon, SearchInput, IconButton } from './styles';

class Search extends React.PureComponent {
  render() {
    const { t } = this.context;
    // Clear the search input if no query is given
    if (!this.props.query && this.searchInput) {
      this.searchInput.value = '';
    }
    return (
      <Row style={{ position: 'relative' }}>
        <SearchInput
          onBlur={e => {
            if (e.currentTarget.value) {
              this.props.campaignSearchDone();
            }
          }}
          defaultValue={this.props.query}
          placeholder={t('campaigns', 'search.placeholder')}
          type="search"
          onChange={e =>
            this.props.onSearch({
              id: 'query',
              value: e.currentTarget.value,
            })
          }
          ref={input => {
            this.searchInput = input;
            if (this.searchInput) {
              this.searchInput.value = this.props.query || '';
            }
          }}
        />
        {(this.searchInput && this.searchInput.value.length) ||
        this.props.query ? (
          <IconButton
            type="button"
            onClick={() => {
              this.props.onSearch({ id: 'query', value: '' });
              this.searchInput.value = '';
              this.searchInput.focus();
            }}
          >
            <IconClose size={12} />
          </IconButton>
        ) : (
          <IconButton
            type="button"
            onClick={() => {
              this.searchInput.focus();
            }}
          >
            <SearchIcon size={20} />
          </IconButton>
        )}
      </Row>
    );
  }
}

const { func, string } = PropTypes;

Search.propTypes = {
  query: string,
  onSearch: func,
  campaignSearchDone: func.isRequired,
};

Search.defaultProps = {
  query: undefined,
};

Search.contextType = AppContext;

export default connect(null, actions)(Search);
